import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ViewService } from '../service/view.service';

@Injectable({
    providedIn: 'root'
})
export class ViewValidators
{
    constructor(private viewService: ViewService) { }

    public validateViewNameUnique(control: UntypedFormControl, initialCategoryName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && initialCategoryName !== control.value)
            {
                this.viewService.viewByNameExists(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ nameExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }
        });
    }
}
